iScreenWizard.controller(
    "CompetentieprofielController",
    function (
        $scope,
        $state,
        $mdDialog,
        $filter,
        Ajax,
        Dictionary,
        ErrorHandler,
        userService,
        Competentieprofiel,
        Competentiegroep,
        Competentie,
        Opleidingsgroep
    ) {
        var pagesize = 20;

        $scope.userService = userService;

        $scope.searchTerm = "";

        $scope.orderBy = "titel";
        $scope.desc = false;
        $scope.competentieprofielen = [];
        $scope.competentieprofielenPage = 1;
        $scope.competentieprofielenMorePages = true;
        $scope.alreadyLoading = false;

        $scope.filter = {};

        $scope.focusedCompetentieprofiel = {};

        $scope.opleidingsgroepen = [];

        $scope.$on("$stateChangeSuccess", function (event, toState) {
            $scope.refresh();
        });

        var refresh = function () {
            $scope.competentieprofielenPage = 1;
            $scope.competentieprofielen = [];
            $scope.loadCompetentieprofielen();

            Opleidingsgroep.all().then(function (opleidingsgroepen) {
                $scope.opleidingsgroepen = opleidingsgroepen;
            });
        };
        $scope.refresh = refresh;

        $scope.loadMoreCompetentieprofielen = function () {
            $scope.competentieprofielenPage =
                $scope.competentieprofielenPage + 1;
            $scope.loadCompetentieprofielen();
        };

        $scope.loadCompetentieprofielen = function () {
            if (!$scope.alreadyLoading) {
                $scope.alreadyLoading = true;
                params = {
                    pagesize: pagesize,
                    page: $scope.competentieprofielenPage,
                    orderby: $scope.orderBy ? $scope.orderBy : "titel",
                    orderdesc: $scope.desc ? 1 : 0,
                };
                if ($scope.searchTerm.length > 0) {
                    params.titel = $scope.searchTerm;
                }
                if ($scope.filter.opleidingsgroep_id > 0) {
                    params.opleidingsgroep_id =
                        $scope.filter.opleidingsgroep_id;
                }
                if ($scope.filter.is_thema >= 0) {
                    params.is_thema = $scope.filter.is_thema;
                }
                if ($scope.filter.personal_only > 0) {
                    params.gebruiker_id = userService.model.id;
                }

                Competentieprofiel.all(params).then(function (
                    competentieprofielen
                ) {
                    $scope.alreadyLoading = false;
                    angular.forEach(
                        competentieprofielen,
                        function (competentieprofiel) {
                            $scope.competentieprofielen.push(
                                competentieprofiel
                            );
                        }
                    );
                    if (competentieprofielen.length < pagesize) {
                        $scope.competentieprofielenMorePages = false;
                    }
                });
            }
        };

        $scope.sortComptentieprofielen = function (orderBy) {
            if ($scope.orderBy == orderBy) {
                $scope.desc = !$scope.desc;
            } else {
                $scope.desc = false;
            }
            $scope.orderBy = orderBy;

            $scope.competentieprofielenPage = 1;
            $scope.competentieprofielen = [];
            $scope.competentieprofielenMorePages = true;
            $scope.loadCompetentieprofielen();
        };

        $scope.searchCompetentieprofiel = function () {
            $scope.competentieprofielenPage = 1;
            $scope.competentieprofielen = [];
            $scope.competentieprofielenMorePages = true;
            $scope.loadCompetentieprofielen();
        };

        $scope.downloadCompetentieprofielVoorbeeld = function (
            competentieprofiel,
            ev
        ) {
            $mdDialog.show({
                controller: DownloadCompetentieprofielVoorbeeldDialogController,
                locals: {
                    competentieprofiel: competentieprofiel,
                },
                templateUrl: "/competentieprofielen/download-voorbeeld",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            });
        };

        function DownloadCompetentieprofielVoorbeeldDialogController(
            $scope,
            $mdDialog,
            competentieprofiel
        ) {
            $scope.competentieprofiel = competentieprofiel;
            $scope.stillLoading = true;
            $scope.downLoadUrl = "";

            Competentieprofiel.downloadVoorbeeld(competentieprofiel).then(
                function (response) {
                    $scope.stillLoading = false;
                    if (ErrorHandler.hasErrors(response)) {
                        ErrorHandler.showDialog(response);
                    } else {
                        $scope.downLoadUrl =
                            baseUrl +
                            response.data.file_url +
                            "?jwt=" +
                            userService.getToken();
                    }
                }
            );
        }

        $scope.addCompetentieprofiel = function (ev) {
            $scope.focusedCompetentieprofiel = {};
            $scope.showCompetentieprofielEditDialog(
                $scope.focusedCompetentieprofiel,
                ev
            );
        };
        $scope.editCompetentieprofiel = function (competentieprofiel, ev) {
            $scope.loadCompetentieprofielThenShowDialog(
                competentieprofiel,
                ev,
                false
            );
        };

        $scope.copyCompetentieprofiel = function (competentieprofiel, ev) {
            $scope.loadCompetentieprofielThenShowDialog(
                competentieprofiel,
                ev,
                true
            );
        };

        $scope.loadCompetentieprofielThenShowDialog = function (
            competentieprofiel,
            ev,
            resetId
        ) {
            Competentieprofiel.getLinkedCompetentieIdeaalscores(
                competentieprofiel
            ).then(function (ideaalscore_per_competentie_id) {
                competentieprofiel.ideaalscore_per_competentie_id =
                    ideaalscore_per_competentie_id;
                if (competentieprofiel.is_thema) {
                    Competentiegroep.all({
                        competentieprofiel_id: competentieprofiel.id,
                    }).then(function (competentiegroepen) {
                        angular.copy(
                            competentieprofiel,
                            $scope.focusedCompetentieprofiel
                        );
                        if (resetId) {
                            $scope.focusedCompetentieprofiel.id = null;
                        }
                        $scope.focusedCompetentieprofiel.competentiegroepen =
                            [];
                        if (competentiegroepen.length < 1) {
                            $scope.showCompetentieprofielEditDialog(
                                $scope.focusedCompetentieprofiel,
                                ev
                            );
                        }
                        angular.forEach(
                            competentiegroepen,
                            function (competentiegroep, key) {
                                Competentiegroep.getLinkedCompetenties(
                                    competentiegroep
                                ).then(function (competentie_ids) {
                                    competentiegroep.competentie_ids =
                                        competentie_ids;
                                    $scope.focusedCompetentieprofiel.competentiegroepen.push(
                                        competentiegroep
                                    );
                                    if (key >= competentiegroepen.length - 1) {
                                        $scope.showCompetentieprofielEditDialog(
                                            $scope.focusedCompetentieprofiel,
                                            ev
                                        );
                                    }
                                });
                            }
                        );
                    });
                } else {
                    angular.copy(
                        competentieprofiel,
                        $scope.focusedCompetentieprofiel
                    );
                    if (resetId) {
                        $scope.focusedCompetentieprofiel.id = null;
                    }
                    $scope.showCompetentieprofielEditDialog(
                        $scope.focusedCompetentieprofiel,
                        ev
                    );
                }
            });
        };

        var showCompetentieprofielEditDialog = function (
            competentieprofiel,
            ev
        ) {
            $mdDialog.show({
                controller: CompetentieprofielEditDialogController,
                locals: {
                    competentieprofiel: competentieprofiel,
                    opleidingsgroepen: $scope.opleidingsgroepen,
                },
                templateUrl: "/competentieprofielen/edit",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
            });
        };
        $scope.showCompetentieprofielEditDialog =
            showCompetentieprofielEditDialog;

        function CompetentieprofielEditDialogController(
            $scope,
            $mdDialog,
            competentieprofiel,
            opleidingsgroepen
        ) {
            $scope.focusedCompetentieprofiel = competentieprofiel;
            $scope.opleidingsgroepen = opleidingsgroepen;
            $scope.competenties = [];
            $scope.refresh = refresh;

            $scope.setIdealscoresToDefault = function () {
                angular.forEach($scope.competenties, function (competentie) {
                    competentie.ideaalscore = 5;
                });
            };

            $scope.selectAllCompetences = function () {
                $scope.focusedCompetentieprofiel.competenties = [];
                angular.forEach($scope.competenties, function (competentie) {
                    $scope.focusedCompetentieprofiel.competenties.push(
                        competentie
                    );
                });
            };

            $scope.deselectAllCompetences = function () {
                $scope.focusedCompetentieprofiel.competenties = [];
            };

            $scope.addCompetentiegroep = function () {
                $scope.focusedCompetentieprofiel.competentiegroepen.push({
                    titel: "",
                    definitie: "",
                    positie:
                        $scope.focusedCompetentieprofiel.competentiegroepen
                            .length + 1,
                });
            };

            $scope.deleteCompetentiegroep = function (competentiegroep) {
                var index =
                    $scope.focusedCompetentieprofiel.competentiegroepen.indexOf(
                        competentiegroep
                    );
                $scope.focusedCompetentieprofiel.competentiegroepen.splice(
                    index,
                    1
                );
            };

            if (
                typeof $scope.focusedCompetentieprofiel.competentiegroepen ===
                "undefined"
            ) {
                $scope.focusedCompetentieprofiel.competentiegroepen = [];
                angular.forEach(
                    $scope.focusedCompetentieprofiel.competentiegroepen,
                    function (competentiegroep) {
                        competentiegroep.competenties = [];
                    }
                );
                $scope.addCompetentiegroep();
            }

            $scope.wijzigOpleidingsgroep = function () {
                $scope.focusedCompetentieprofiel.competenties = [];
                $scope.loadCompetenties();
            };

            $scope.loadCompetenties = function () {
                var oldLinkedCompetences =
                    $scope.focusedCompetentieprofiel.competenties;
                Competentie.all({
                    actief: 1,
                    opleidingsgroep_id:
                        $scope.focusedCompetentieprofiel.opleidingsgroep_id,
                    intellectuele_capaciteiten: 0,
                }).then(function (competenties) {
                    $scope.competenties = competenties;
                    $scope.focusedCompetentieprofiel.competenties = [];
                    angular.forEach(
                        $scope.competenties,
                        function (competentie) {
                            if (
                                !oldLinkedCompetences &&
                                $scope.focusedCompetentieprofiel
                                    .ideaalscore_per_competentie_id
                            ) {
                                if (
                                    $scope.focusedCompetentieprofiel.ideaalscore_per_competentie_id.hasOwnProperty(
                                        competentie.id
                                    )
                                ) {
                                    competentie.ideaalscore =
                                        $scope.focusedCompetentieprofiel.ideaalscore_per_competentie_id[
                                            competentie.id
                                        ];
                                    $scope.focusedCompetentieprofiel.competenties.push(
                                        competentie
                                    );
                                }
                            }
                            if (oldLinkedCompetences) {
                                angular.forEach(
                                    oldLinkedCompetences,
                                    function (oldCompetentie) {
                                        if (
                                            competentie.id == oldCompetentie.id
                                        ) {
                                            competentie.ideaalscore =
                                                oldCompetentie.ideaalscore;
                                            $scope.focusedCompetentieprofiel.competenties.push(
                                                competentie
                                            );
                                        }
                                    }
                                );
                            }
                        }
                    );
                });
            };

            $scope.loadCompetenties();

            $scope.showCompetentieprofielEditDialog =
                showCompetentieprofielEditDialog;

            $scope.saveCompetentieprofiel = function () {
                var url = "competentieprofiel";
                var params = angular.copy($scope.focusedCompetentieprofiel);
                params.is_centraal = params.is_centraal ? 1 : 0;
                params.is_thema = params.is_thema ? 1 : 0;
                params.competenties = [];
                var isNew = false;
                if ($scope.focusedCompetentieprofiel.id) {
                    //update existing
                    url += "/" + $scope.focusedCompetentieprofiel.id;
                    params._method = "put";
                } else {
                    //add new
                    isNew = true;
                }

                Ajax.post(url, params).then(
                    function (response) {
                        if (response.data.succes) {
                            if (isNew) {
                                $scope.focusedCompetentieprofiel.id =
                                    response.data.id;
                            }
                            Competentieprofiel.linkCompetentieIdeaalscores(
                                $scope.focusedCompetentieprofiel
                            ).then(function (response) {
                                if (response.data.succes) {
                                    if (
                                        $scope.focusedCompetentieprofiel
                                            .is_thema
                                    ) {
                                        //retrieve existing competentiegroepen
                                        Competentiegroep.all({
                                            competentieprofiel_id:
                                                competentieprofiel.id,
                                        }).then(function (
                                            oldCompetentiegroepen
                                        ) {
                                            newCompetentiegroepen =
                                                $scope.focusedCompetentieprofiel
                                                    .competentiegroepen;
                                            angular.forEach(
                                                oldCompetentiegroepen,
                                                function (oldCompetentiegroep) {
                                                    var found = false;
                                                    for (
                                                        var i = 0;
                                                        i <
                                                        newCompetentiegroepen.length;
                                                        i++
                                                    ) {
                                                        if (
                                                            newCompetentiegroepen[
                                                                i
                                                            ].id ==
                                                            oldCompetentiegroep.id
                                                        ) {
                                                            found = true;
                                                            //remove from new list
                                                            oldCompetentiegroep =
                                                                newCompetentiegroepen[
                                                                    i
                                                                ];
                                                            newCompetentiegroepen.splice(
                                                                i,
                                                                1
                                                            );
                                                            break;
                                                        }
                                                    }
                                                    if (found) {
                                                        //update competentiegroep
                                                        Ajax.put(
                                                            "competentiegroep/" +
                                                                oldCompetentiegroep.id,
                                                            oldCompetentiegroep
                                                        );
                                                        Competentiegroep.linkCompetenties(
                                                            oldCompetentiegroep
                                                        );
                                                    } else {
                                                        //delete old competentiegroep
                                                        Ajax.delete(
                                                            "competentiegroep/" +
                                                                oldCompetentiegroep.id
                                                        );
                                                    }
                                                }
                                            );
                                            angular.forEach(
                                                newCompetentiegroepen,
                                                function (competentiegroep) {
                                                    competentiegroep.competentieprofiel_id =
                                                        $scope.focusedCompetentieprofiel.id;
                                                    //save new competentiegroep
                                                    Ajax.post(
                                                        "competentiegroep",
                                                        competentiegroep
                                                    ).then(function (response) {
                                                        competentiegroep.id =
                                                            response.data.id;
                                                        Competentiegroep.linkCompetenties(
                                                            competentiegroep
                                                        );
                                                    });
                                                }
                                            );
                                        });
                                    }

                                    $scope.refresh();
                                    $mdDialog.hide();
                                } else {
                                    ErrorHandler.showDialog(response).then(
                                        $scope.showCompetentieprofielEditDialog(
                                            $scope.focusedCompetentieprofiel
                                        )
                                    );
                                }
                            });
                        } else {
                            ErrorHandler.showDialog(response).then(
                                $scope.showCompetentieprofielEditDialog(
                                    $scope.focusedCompetentieprofiel
                                )
                            );
                        }
                    },
                    function (exception) {
                        ErrorHandler.showDialog(exception);
                    }
                );
            };
        }

        $scope.deleteCompetentieprofiel = function (competentieprofiel, ev) {
            $scope
                .showCompetentieprofielDeleteDialog(competentieprofiel, ev)
                .then(function () {
                    //delete competentieprofiel if user confirmed
                    Ajax.delete(
                        "competentieprofiel/" + competentieprofiel.id
                    ).then(
                        function (response) {
                            if (response.data.succes) {
                                $scope.refresh();
                                $mdDialog.hide();
                            } else {
                                ErrorHandler.showDialog(response);
                            }
                        },
                        function (exception) {
                            //something went wrong
                            ErrorHandler.showDialog(exception);
                        }
                    );
                });
        };

        $scope.showCompetentieprofielDeleteDialog = function (
            competentieprofiel,
            ev
        ) {
            return $mdDialog.show(
                $mdDialog
                    .confirm()
                    .title(
                        Dictionary.translate(
                            "app.delete_competence_profile",
                            true
                        )
                    )
                    .htmlContent(
                        Dictionary.translate("app.confirm_delete", true)
                    )
                    .ariaLabel(
                        Dictionary.translate(
                            "app.delete_competence_profile",
                            true
                        )
                    )
                    .ok(Dictionary.translate("app.okay", true))
                    .cancel(Dictionary.translate("app.cancel", true))
            );
        };

        $scope.getTrainingGroupWithId = function (array, id) {
            var match = null;
            angular.forEach(array, function (object, index) {
                if (object.id === id) {
                    match = object;
                }
            });
            return match;
        };
    }
);
